import { Skeleton } from 'antd';

export function InboxNotificationLoader({ count = 5 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-4 p-2 [&_.ant-skeleton-title]:mt-0!  [&_.ant-skeleton-title]:h-[20px]! [&_.ant-skeleton-paragraph]:mt-[10px]!">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          loading={true}
          active
          avatar={{ shape: 'circle', size: 24 }}
          title={{ width: '50%' }}
          paragraph={{ rows: 1, width: '100%' }}
        />
      ))}
    </div>
  );
}
